export const AVATAR_PERSONAL = `${process.env.NEXT_PUBLIC_BASE_URL}/static/product-ui/user-avatars/my-project.png`
export const AVATAR_TEAM = `${process.env.NEXT_PUBLIC_BASE_URL}/static/product-ui/user-avatars/doist.png`

export function getDefaultAvatar(isTeam: boolean) {
    return isTeam ? AVATAR_TEAM : AVATAR_PERSONAL
}
